import { useCallback, useSyncExternalStore } from 'react';
import { navigationStore } from '@bridge/navigationStore';

export function useNavigationStore() {
  const snapshot = useSyncExternalStore(
    navigationStore.subscribe,
    navigationStore.getSnapshot,
    navigationStore.getSnapshot,
  );
  const getCustomer = useCallback(
    () =>
      snapshot.context?.type === 'customer' &&
      /^customer(\.|$)/.test(snapshot.activeState)
        ? snapshot.context.customer
        : null,
    [snapshot.activeState, snapshot.context],
  );

  return { ...snapshot, getCustomer };
}
